import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { 
  Contact, 
  ContactSearchCriteria
} from '../../_models/contact.model';
import { ApiResponse } from '../../_models/api-response.model';
import { Page } from '../../_models/page.model';

@Injectable({
  providedIn: 'root'
})
export class AdminContactService {
  private apiUrl = `${environment.apiUrl}/contacts`;

  constructor(private http: HttpClient) {}

  // Get all contacts with search criteria
  getAllContacts(
    criteria: ContactSearchCriteria = {},
    page: number = 0, 
    size: number = 10, 
    sort: string = 'createdAt', 
    direction: string = 'DESC'
  ): Observable<ApiResponse<Page<Contact>>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', sort)
      .set('direction', direction);

   if (criteria.search) {
      params = params.set('search', criteria.search);
    }
    if (criteria.isRead !== undefined) {
      params = params.set('isRead', criteria.isRead.toString());
    }
    if (criteria.email) {
      params = params.set('email', criteria.email);
    }
    if (criteria.isArchived !== undefined) {
      params = params.set('isArchived', criteria.isArchived.toString());
    }

    return this.http.get<ApiResponse<Page<Contact>>>(this.apiUrl, { params });
  }

  // Get contact details by ID
  getContactDetails(contactId: number): Observable<ApiResponse<Contact>> {
    return this.http.get<ApiResponse<Contact>>(`${this.apiUrl}/${contactId}`);
  }

  // Get unread contact count
  getUnreadContactCount(): Observable<ApiResponse<number>> {
    return this.http.get<ApiResponse<number>>(`${this.apiUrl}/unread-count`);
  }

  // Mark contact as read
  markAsRead(contactId: number): Observable<ApiResponse<void>> {
    return this.http.post<ApiResponse<void>>(`${this.apiUrl}/${contactId}/mark-read`, {});
  }

  // Mark contact as unread
  markAsUnread(contactId: number): Observable<ApiResponse<void>> {
    return this.http.post<ApiResponse<void>>(`${this.apiUrl}/${contactId}/mark-unread`, {});
  }

  // Delete contact
  deleteContact(contactId: number): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.apiUrl}/${contactId}`);
  }

  // Archive contact
  archiveContact(contactId: number): Observable<ApiResponse<void>> {
    return this.http.post<ApiResponse<void>>(`${this.apiUrl}/${contactId}/archive`, {});
  }

  // Unarchive contact
  unarchiveContact(contactId: number): Observable<ApiResponse<void>> {
    return this.http.post<ApiResponse<void>>(`${this.apiUrl}/${contactId}/unarchive`, {});
  }
}